// extracted by mini-css-extract-plugin
module.exports = {"copy":"CopyToClipboard_copy__QP5Gh","wrapper":"CopyToClipboard_wrapper__2STU2","tooltip":"CopyToClipboard_tooltip__28b7r","icon":"CopyToClipboard_icon__CuPv9"};